import { jsx as o, jsxs as s } from "react/jsx-runtime";
import * as r from "@radix-ui/react-tooltip";
import { clsx as w } from "../../node_modules/clsx/dist/clsx.js";
import { Fragment as a } from "react";
import x from "./arrow.svg.js";
import { trigger as u, arrow as N, content as v } from "./index.css.js";
function R({
  content: l,
  children: n,
  className: m,
  variant: c = "primary",
  disablePortal: g = !1,
  arrow: t = !0,
  fullWidth: e = !1,
  contentProps: i,
  ...f
}) {
  const d = g ? a : r.Portal, p = t ? r.Arrow : a, h = e ? e === "trigger" ? "trigger" : "screen" : null;
  return /* @__PURE__ */ o(r.Provider, { children: /* @__PURE__ */ s(r.Root, { ...f, children: [
    /* @__PURE__ */ o(r.Trigger, { className: u, asChild: !0, children: n }),
    /* @__PURE__ */ o(d, { children: /* @__PURE__ */ s(
      r.Content,
      {
        ...i,
        alignOffset: 6,
        className: w(
          v,
          m,
          i?.className,
          c,
          h
        ),
        children: [
          l,
          /* @__PURE__ */ o(
            p,
            {
              ...t && {
                asChild: !0,
                className: N,
                children: /* @__PURE__ */ o(x, { viewBox: "0 0 16 9" })
              }
            }
          )
        ]
      }
    ) })
  ] }) });
}
export {
  R as Tooltip
};
//# sourceMappingURL=index.js.map
